import { render, staticRenderFns } from "./FacetField.vue?vue&type=template&id=39b82e56&scoped=true&"
import script from "./FacetField.vue?vue&type=script&lang=js&"
export * from "./FacetField.vue?vue&type=script&lang=js&"
import style0 from "./FacetField.vue?vue&type=style&index=0&id=39b82e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b82e56",
  null
  
)

export default component.exports